import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => { clearToken(); })
      .finally(() => setLoading(false));
  }, []);

  const loginSuccess = useCallback((data) => {
    setToken(data.token);
    setUser(data.user);
  }, []);

  const refreshUser = useCallback(async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.warn("Logout request failed (clearing session anyway):", err); }
    clearToken();
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, loading, loginSuccess, logout, refreshUser }), [user, loading, loginSuccess, logout, refreshUser]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
